define('Components/MenuWidget/js/models/MenuWidgetInstanceModel',['underscore','WidgetInstanceModel','app'],function(_,WidgetInstanceModel,app){
    return WidgetInstanceModel.extend({
        name:'MenuWidgetModel',
        getMenu:function(){
            return app.getMenuBySlug(this.p('menuidentifiant'));
        },
        getItems:function(){
            var menu = this.getMenu();
            if(menu){
                return menu.getItems()
            }else{
                return _([]);
            }
        }
    })
});
